(ns humbleai.belt.malli.type.schema
  (:refer-clojure :exclude [type])
  (:require
   [clojure.test.check.generators :as gen]
   [malli.generator :as mg]
   [malli.core :as malli]
   [humbleai.belt.malli.core :as core]))

(def type
  ;; Keyed `:malli/schema`, NOT `:schema`: malli reserves the bare `:schema`
  ;; keyword for its built-in wrapper/`:ref` recursion combinator, so overriding
  ;; it in the default registry breaks every recursive/ref schema in the app.
  {:malli/schema (malli/-simple-schema
                  {:type :malli/schema
                   :pred core/schema})})

(def schema-gen
  "Generates simple, always-valid malli schema forms."
  (gen/elements [:any :string :int :double :boolean :keyword :symbol
                 :uuid :qualified-keyword :qualified-symbol]))

(defmethod mg/-schema-generator :malli/schema [_ _] schema-gen)

(defn ->schema
  "Compile `x` into a malli schema, leaving it untouched when it is not one, so a
   non-schema flows through to validation rather than being nilled out."
  [x]
  (or (core/schema x) x))

(def transformer
  {:name :schema-transformer
   :decoders {:malli/schema ->schema}})
